// Color schemes from https://colorbrewer2.org

export const getHexFromColor = (color) => {
  return color.split("'")[1];
}

const white = "color('#ffffff')";
const grey = "color('lightgrey')";

// Flooding based on 6-class PuBu
// const floodColor1 = "color('#f1eef6')";
// const floodColor2 = "color('#d0d1e6')";
// const floodColor3 = "color('#a6bddb')";
// const floodColor4 = "color('#74a9cf')";
// const floodColor5 = "color('#2b8cbe')";
// const floodColor6 = "color('#045a8d')";

// Flooding based on 6-class YlGnBu
const floodColor1 = "color('#ffffcc')";
const floodColor2 = "color('#c7e9b4')";
const floodColor3 = "color('#7fcdbb')";
const floodColor4 = "color('#41b6c4')";
const floodColor5 = "color('#2c7fb8')";
const floodColor6 = "color('#253494')";

// Damages based on 6-class OrRd
const damColor1 = "color('#fef0d9')";
const damColor2 = "color('#fdd49e')";
const damColor3 = "color('#fdbb84')";
const damColor4 = "color('#fc8d59')";
const damColor5 = "color('#e34a33')";
const damColor6 = "color('#b30000')";

const negDamColor = "color('#54278f')"

export const sixFloodingColors = [
  grey, floodColor2, floodColor3, floodColor4, floodColor5, floodColor6
];
export const fiveFloodingColors = [
  grey, floodColor3, floodColor4, floodColor5, floodColor6
];
// export const sixFloodingColorsReversed = [
//   floodColor6, floodColor5, floodColor4, floodColor3, floodColor2, grey
// ];
// export const fiveFloodingColorsReversed = [
//   floodColor6, floodColor5, floodColor4, floodColor3, grey
// ];

export const sixDamageColors = [
  negDamColor, grey, damColor3, damColor4, damColor5, damColor6
];
export const fiveDamageColors = [
  grey, damColor3, damColor4, damColor5, damColor6
];
// export const sixDamageColorsReversed = [
//   damColor6, damColor5, damColor4, damColor3, grey, negDamColor
// ];
// export const fiveDamageColorsReversed = [
//   damColor6, damColor5, damColor4, damColor3, grey
// ];
// export const fourDamageColorsReversed = [
//   damColor6, damColor5, damColor4, grey
// ];

// Damages Prevented
export const damagesPrevBps = ['<= 0', '< 1000000', '< 5000000', '< 20000000', '>= 20000000'];
export const damagesPrevColors = fiveDamageColors;

// Damages WP and WoP
export const damagesBps = ['=== 0', '< 1000000', '< 5000000', '< 20000000', '>= 20000000'];
export const damagesColors = fiveDamageColors;

// Flooding for Roads
export const roadFloodingBps = ['<= 0', '< 0.1', '< 0.5', '< 1', '< 2', '>= 2'];
// export const roadFloodingBps = ['> 2', '> 1', '> 0.5', '> 0.1', '> 0', '=== 0'];
// export const roadFloodingBps = ['> 2', '> 1', '> 0.5', '> 0.1', '> 0'];
export const roadFloodingColors = sixFloodingColors;

// Flooding for Structures
export const structFloodingBps = roadFloodingBps;
// export const structFloodingBps = ['<= 0', '< 1', '< 2', '< 5', '< 10', '>= 10'];
// export const structFloodingBps = ['> 10', '> 5', '> 2', '> 1', '> 0', '=== 0'];
// export const structFloodingBps = ['> 10', '> 5', '> 2', '> 1', '> 0', '<= 0'];
export const structFloodingColors = sixFloodingColors;
